import React, { Ref } from 'react'
import styled from 'styled-components'
import { Upload } from 'antd'
import { DraggerProps } from 'antd/lib/upload'

export type Props = DraggerProps & {
  children: React.ReactNode
}

const { Dragger } = Upload

export const StyleDragger = styled(Dragger)`
  &.ant-upload.ant-upload-drag {
    background-color: ${p => p.theme.block.content};
    border: none;
    width: 320px;
    padding: 30px 69px 4px;

    p.ant-upload-drag-icon .anticon {
      color: ${p => p.theme.darkGrey};
    }

    p {
      &.ant-upload-text {
        font-size: 14px;
        font-weight: normal;
        color: ${p => p.theme.primary};
      }

      &.ant-upload-hint {
        font-size: 10px;
        font-weight: normal;
        color: ${p => p.theme.darkGrey};
      }
    }

    .ant-upload-btn {
      padding: 0;
    }
  }
`

function DraggerBox({ children, ...porps }: Props, ref: Ref<any>) {
  return <StyleDragger {...porps}>{children}</StyleDragger>
}

export default React.forwardRef(DraggerBox)
